export const getSelectedUrlParams = (parameterNames: string[]): Record<string, string> => {
  const params = new URLSearchParams(window.location.search);
  const capturedParams: Record<string, string> = {};

  parameterNames.forEach((parameterName) => {
    const value = params.get(parameterName);
    if (value) {
      capturedParams[parameterName] = value;
    }
  });

  return capturedParams;
};
